// extracted by mini-css-extract-plugin
export var cartContainer = "_jq-4";
export var gray = "_jq-1";
export var itemContainer = "_jq-2";
export var itemDetails = "_jq-3";
export var strong = "_jq-0";